import styled, { css } from 'styled-components';

import Icon from '#@/components/Icon';
import { COLOR, mixins, textStyles } from '#@/shared/utils/styles';

export const CONTAINER_GAP = 12;
export const CONTAINER_PADDING = 2;
export const CHECKBOX_SIZE = 18;
const CHECKBOX_ICON_SIZE = 12;

export const StyledCheckbox = styled.input.attrs({ type: 'checkbox' })`
  height: ${CHECKBOX_SIZE}px;
  width: ${CHECKBOX_SIZE}px;
  margin: 0;
  border: 1px solid ${COLOR.borderMedium};
  border-radius: 4px;
  background-color: ${COLOR.white};
  cursor: pointer;

  &:checked,
  &:indeterminate {
    border-color: var(--main-color);
    background-color: var(--main-color);
  }

  &:focus-visible:not(:disabled) {
    outline: 2px solid var(--outline-color);

    /* When :focus-visible, Chrome seems to apply extra offset for some reason */
    outline-offset: 0;

    &:not(:checked, :indeterminate) {
      border-color: var(--highlight-color);
    }
  }

  &:hover:not(:disabled) {
    border-color: var(--highlight-color);

    &:checked,
    &:indeterminate {
      background-color: var(--highlight-color);
    }
  }

  &:disabled {
    border-color: ${COLOR.backgroundMedium};
    background-color: ${COLOR.backgroundMedium};
    cursor: not-allowed;
  }
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: ${CONTAINER_GAP}px;
  overflow: hidden;
`;

export const Label = styled.label<{ $invalid: boolean; $disabled: boolean }>`
  display: flex;
  align-items: center;
  gap: ${CONTAINER_GAP}px;
  padding: ${CONTAINER_PADDING}px;
  cursor: ${(props) => (props.$disabled ? 'text' : 'pointer')};
  ${textStyles.bodyMedium450}
  color: ${COLOR.textSecondary};
  overflow: hidden;

  --main-color: ${(props) => (props.$invalid ? COLOR.danger : COLOR.brand)};
  --highlight-color: ${(props) => (props.$invalid ? COLOR.danger : COLOR.highlightNeon)};
  --outline-color: ${(props) =>
    props.$invalid ? mixins.rgba(COLOR.danger, 0.2) : mixins.rgba(COLOR.brand, 0.2)};

  ${StyledCheckbox} {
    ${(props) =>
      props.$invalid &&
      css`
        border-color: ${COLOR.danger};
      `}
  }
`;

export const CheckboxWrapper = styled.div`
  height: ${CHECKBOX_SIZE}px;
  width: ${CHECKBOX_SIZE}px;
  position: relative;
`;

export const CheckboxIcon = styled(Icon).attrs({ size: CHECKBOX_ICON_SIZE })<{
  $disabled: boolean;
}>`
  position: absolute;
  top: ${(CHECKBOX_SIZE - CHECKBOX_ICON_SIZE) / 2}px;
  left: ${(CHECKBOX_SIZE - CHECKBOX_ICON_SIZE) / 2}px;
  color: ${COLOR.white};

  ${(props) =>
    props.$disabled &&
    css`
      color: ${COLOR.textTertiary};
    `}
`;
